// ─────────────────────────────────────────────────────────────────
// Glass-i — Account Reports constants (Stage 6B.5).
//
// Shared enums + display maps for the 4 read-only reports:
//   - Trial Balance
//   - Ledger Statement
//   - Voucher Register / Day Book
//   - Account Balances
// ─────────────────────────────────────────────────────────────────

export const ACCOUNT_TYPES = ['asset', 'liability', 'equity', 'income', 'expense'];

export const ACCOUNT_TYPE_LABEL = {
  asset:     'Asset',
  liability: 'Liability',
  equity:    'Equity',
  income:    'Income',
  expense:   'Expense'
};

export const ACCOUNT_TYPE_COLOR = {
  asset:     'blue',
  liability: 'magenta',
  equity:    'gold',
  income:    'green',
  expense:   'volcano'
};

// Voucher Register status filter — adds 'all' to the canonical set.
export const VOUCHER_REGISTER_STATUSES = [
  { value: 'posted',    label: 'Posted only',  color: 'green'   },
  { value: 'cancelled', label: 'Cancelled',    color: 'red'     },
  { value: 'draft',     label: 'Drafts',       color: 'default' },
  { value: 'all',       label: 'All statuses', color: 'blue'    }
];

export const VOUCHER_STATUS_COLOR = {
  draft:     'default',
  posted:    'green',
  cancelled: 'red'
};

export const VOUCHER_TYPE_LABEL = {
  journal:     'Journal',
  payment:     'Payment',
  receipt:     'Receipt',
  sales:       'Sales',
  purchase:    'Purchase',
  credit_note: 'Credit Note',
  debit_note:  'Debit Note',
  adjustment:  'Adjustment'
};

export const VOUCHER_TYPES = Object.keys(VOUCHER_TYPE_LABEL);

// Pretty currency. Locale-aware (en-IN); 2dp; no symbol so the column
// header can carry the ₹.
export function formatINR(n) {
  const v = Number(n) || 0;
  return v.toLocaleString('en-IN', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  });
}

// Short YYYY-MM-DD slice (the API returns ISO timestamps).
export function shortDate(v) {
  return v ? String(v).slice(0, 10) : '—';
}
